// extracted by mini-css-extract-plugin
export var boxItems = "_2k-1";
export var boxItemsLg = "_2k-2";
export var button = "_2k-7";
export var buttonHoverless = "_2k-9";
export var buttonLg = "_2k-8";
export var filterGroupBox = "_2k-0";
export var icon = "_2k-3";
export var iconSecondary = "_2k-6";
export var iconWrapper = "_2k-4";
export var iconWrapperLg = "_2k-5";
export var truncatedLabel = "_2k-a";